
import { useResourceUsage } from './use-resource-usage';
import { useSubscriptionData } from './use-subscription-data';
import { useAuth } from '@/contexts/AuthContext';

export const usePropTradingAccountValidation = () => {
  const { user } = useAuth();
  const { data: subscriptionData } = useSubscriptionData(user?.id);
  const { data: resourceUsage } = useResourceUsage(user?.id);

  const canStartChallenge = () => {
    if (!subscriptionData?.package || !resourceUsage) {
      return false;
    }

    return resourceUsage.propBotAccountsCount < subscriptionData.package.max_prop_bots;
  };

  const getErrorMessage = () => {
    if (!subscriptionData?.package) {
      return 'No active subscription found. Please upgrade to start prop trading challenges.';
    }

    if (resourceUsage && resourceUsage.propBotAccountsCount >= subscriptionData.package.max_prop_bots) {
      return `You've reached your limit of ${subscriptionData.package.max_prop_bots} prop trading accounts. Please upgrade your subscription to add more accounts.`;
    }

    return null;
  };

  return {
    canStartChallenge,
    getErrorMessage,
    currentCount: resourceUsage?.propBotAccountsCount || 0,
    maxAccounts: subscriptionData?.package?.max_prop_bots || 0
  };
};
